export enum AccessModules {
  BasicPosMarket = 'basic_pos_market',
  BasicPosProduct = 'basic_pos_product',
  BrandInsightsCie = 'brand_insights_cie',
  BrandInsightsPos = 'brand_insights_pos',
  Forecasting = 'forecasting',
  Metadata = 'metadata',
  NewronInsights = 'newron_insights',
  PosDistributionMarket = 'pos_distribution_market',
  PosDistributionProduct = 'pos_distribution_product',
  PriceElasticity = 'price_elasticity',
  Recommendations = 'recommendations',
  TprInsights = 'tpr_insights',
  TprPlanning = 'tpr_planning',
  Tracking = 'tracking',
}

export interface PageParameter {
  name: string
  type: PageParameterType
  required: boolean
}

export enum PageParameterType {
  COUNTRY = 'country',
  ITEMGROUP = 'itemGroup',
  BRAND = 'brand',
}

export enum PageType {
  GLOBAL_SUMMARY,
  PRODUCTS,
  SEGMENTATION,
  PRODUCT,
  REVENUE_PREMIUM,
  PERFORMANCE_DRIVERS,
  CONVERSION_OPPORTUNITIES,
  PURCHASE_FUNNEL,
  CONSUMER_PERCEPTION,
  PROMOTION_PLANNER,
  BRAND,
  FORECASTING,
  RECOMMENDATIONS,
  OVERVIEW,
  CIE,
  PRICING,
  PROMOTIONS,
}
export enum Periodicity {
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}

export interface UserAccess {
  modules: string[]
  periodicities: Periodicity[]
  products?: string[]
}

export interface Page {
  title: string
  type: PageType
  path?: string | string[]
  /**
   * If provided the navigation menu will use the given regular expression to match the
   * current location path from react-router to detect which item is
   * currently active. This is required for routes that include nested
   * tabs/routes themselves.
   */
  match?: RegExp
  accessModules: AccessModules[]
  redirect?: string
  parameters?: PageParameter[]
}

/**
 * Defines a Navigation Item
 */
export interface NavigationItem extends NavigationTreeItem {
  /**
   * The label text the users sees for the navigation item
   */
  title: string
  /**
   * Where to navigate to when the link is pressed. Not required for parent items
   */
  path?: string
  /**
   * If provided the navigation menu will use the given regular expression to match the
   * current location path from react-router to detect which item is
   * currently active. This is required for routes that include nested
   * tabs/routes themselves.
   */
  match?: RegExp
  /**
   * If present, the link to the component will also include the current
   * query params as provided by react router.
   *
   * @see useSearchParams()
   */
  includesQueryParams?: boolean
  /**
   * Used to define a set of links when the item is a parent.
   */
  navigationChildren?: NavigationItem[]
}

export interface NavigationTreeItem {
  type?: PageType

  /**
   * The label text the users sees for the navigation item
   */
  title?: string

  /**
   * Used for adding a <code>data-test-id<code>
   */
  testId: string
  /**
   * Optional predicate to define whether the item should be displayed.
   * Useful for cases where some items are hidden behind feature flags
   * or require specific privileges.
   */
  display?: () => boolean
  /**
   * If supplied, this value will be used when firing an analytics
   * event for when the user navigates using this item. Otherwise
   * the analytics event will use the title.
   */
  trackingText?: string
  /**
   * Used to define a set of links when the item is a parent.
   */
  navigationChildren?: NavigationTreeItem[]
  /**
   * Icon to show before item's label.
   */
  icon?: any
  /**
   * Defines to which modules the user needs to have access to see
   * the item. This will only hide the item, not prevent the route
   * from being available.
   */
  accessModules?: AccessModules[]
  path?: string
  child?: boolean
}

export const CIE_PRODUCT = 'cie'
export const CIE_UPSELL = 'consumer_upsell'
export const RETAIL_INSIGHTS_PRODUCT = 'retail_insights'
export const PROMOTION_PRICING = 'Pricing'
